/**************************************************
 * Nombre:       Formulario_Programa_PerfilEmpre_Lideres
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";

const Formulario_Programa_PerfilEmpre_Lideres = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 14}}>**Icono de 200px por 200px de menos
                        de 300K de
                        peso</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCrop dato={'img'} alto={1} ancho={1} {...props}  />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Nombre del lider'}
                                  dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Descripcion'}
                                  dato={'descripcion'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Programa_PerfilEmpre_Lideres